// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1.19.2/static/js/" + chunkId + "." + {"275":"c46eb56f","450":"79bdb771"}[chunkId] + ".chunk.js";
};